import React from "react";
import { Row } from "reactstrap";
import CardStatistiqueItem from "./cardStatistiqueItem";
import { useQuery } from "react-query";
import { getVehicules } from "../../../Vehicules/services/vehiculeApi";
import { getDrivers } from "../../../Users/services/userApi";
import { getInspection } from "../../../Inspection/services/inspectionsApi";
import { useTranslation } from "react-i18next";

const CardStatistique = () => {
    const { data: vehicles } = useQuery("vehicules", getVehicules);
    const { data: inspection } = useQuery("inspections", getInspection);
    const inspections = inspection?.filter(insp => insp.typeInspection !== "Incident");
    const incidents = inspection?.filter(insp => insp.typeInspection === "Incident");
    const { data: users } = useQuery("users", getDrivers);
    const drivers = users?.filter(user => user.role?.name === "DRIVER");

    const activeDriversCount = drivers?.filter(driver => driver?.status?.toLowerCase() === "actif").length || 0;
    const inactiveDriversCount = drivers?.filter(driver => driver?.status?.toLowerCase() === "inactif").length || 0;
    const archivedDriversCount = drivers?.filter(driver => driver?.archived === true).length || 0;

    const inServiceVehiclesCount = vehicles?.filter(vehicle => vehicle?.statut?.toLowerCase() === "en service").length || 0;
    const outOfServiceVehiclesCount = vehicles?.filter(vehicle => vehicle?.statut?.toLowerCase() === "hors service").length || 0;
    const archivedVehiclesCount = vehicles?.filter(vehicle => vehicle?.archived === true).length || 0

    const interiorInspectionsCount = inspections?.filter(inspection => inspection?.category?.toLowerCase() === "interior").length || 0;
    const exteriorInspectionsCount = inspections?.filter(inspection => inspection?.category?.toLowerCase() === "exterior").length || 0;
    const functionalInspectionsCount = inspections?.filter(inspection => inspection?.category?.toLowerCase() === "functional").length || 0;

    const pendingInc = incidents?.filter(inc => inc?.status?.toLowerCase() === "en attente").length || 0;
    const doneInc = incidents?.filter(inc => inc?.status?.toLowerCase() === "résolues").length || 0;
    const archInc = incidents?.filter(inc => inc?.status?.toLowerCase() === "Archivé").length || 0;
        const { t } = useTranslation();

    const statsData = [
        {
            title: t("dashboard.drivers"),
            icon: "crosshair",
            className: "text-success",
            url: "/chauffeurs",
            counterStart: 0,
            counterEnd: drivers?.length || "-",
            counterDuration: 4,
            stats: [
                { label: t("dashboard.actif"), value: activeDriversCount, align: "text-left" },
                { label: t("dashboard.inactif"), value: inactiveDriversCount, align: "text-left" },
                { label: t("dashboard.archive"), value: archivedDriversCount, align: "text-left" }
            ],
        },
       /* {
            title: t("dashboard.vehicles"),
            icon: "hard-drive",
            url: "/vehicules",
            className: "text-info",
            counterStart: 0,
            counterEnd: vehicles?.length || "-",
            counterDuration: 4,
            stats: [
                { label: t("dashboard.enService"), value: inServiceVehiclesCount, align: "text-center" },
                { label: t("dashboard.horsService"), value: outOfServiceVehiclesCount, align: "text-center" },
                { label: t("dashboard.enReparation"), value: archivedVehiclesCount, align: "text-left" }
            ],
        }*/
        {
            title: t("dashboard.inspections"),
            icon: "bookmark",
            url: "/inspection",
            className: "text-warning",
            counterStart: 0,
            counterEnd: inspections?.length || "-",
            counterDuration: 4,
            stats: [
                { label: t("dashboard.interior"), value: interiorInspectionsCount, align: "text-left" },
                { label: t("dashboard.exterior"), value: exteriorInspectionsCount, align: "text-center" },
                { label: t("dashboard.functional"), value: functionalInspectionsCount, align: "text-center" }
            ],
        },
        {
            title: t("dashboard.incidents"),
            icon: "bookmark",
            url: "/incidents",
            className: "text-warning",
            counterStart: 0,
            counterEnd: incidents?.length || "-",
            counterDuration: 4,
            stats: [
                { label: t("dashboard.enAttente"), value: pendingInc, align: "text-left" },
                { label: t("dashboard.resolue"), value: doneInc, align: "text-center" },
                { label: t("dashboard.archive"), value: archInc, align: "text-center" }
            ],
        },
    ];

    return (
        <Row>
            {statsData.map((card, index) => (
                <CardStatistiqueItem     
                    key={index}
                    title={card.title}
                    icon={card.icon}
                    className={card.className}
                    url={card.url}
                    counterStart={card.counterStart}
                    counterEnd={card.counterEnd}
                    counterDuration={card.counterDuration}
                    stats={card.stats}
                />
            ))}
        </Row>
    );
};

export default CardStatistique;
